
(function () {
  function fixSingleLogoAndTrending() {
    var header = document.querySelector('#goldenHomeFileHero');
    if (header) {
      var logoWrap = header.querySelector('.ghFileLogo');
      if (logoWrap) {
        var imgs = logoWrap.querySelectorAll('img');
        imgs.forEach(function (img, index) {
          if (index > 0 || /black|clean/i.test(img.getAttribute('src') || '')) {
            img.style.display = 'none';
            img.style.visibility = 'hidden';
            img.style.opacity = '0';
            img.style.width = '0';
            img.style.height = '0';
          } else {
            img.style.display = 'block';
            img.style.visibility = 'visible';
            img.style.opacity = '1';
          }
        });
      }

      var left = header.querySelector('.ghFileLeft');
      if (left && logoWrap) {
        Array.prototype.slice.call(left.children).forEach(function (child) {
          if (child === logoWrap) return;
          if (child.classList && (child.classList.contains('ghFileMenu') || child.classList.contains('ghFileNav'))) return;
          var img = child.matches && child.matches('img') ? child : child.querySelector && child.querySelector('img');
          if (img && /logo|ghome|golden/i.test(img.getAttribute('src') || img.alt || '')) {
            child.style.display = 'none';
            child.style.visibility = 'hidden';
            child.style.opacity = '0';
            child.style.width = '0';
            child.style.height = '0';
          }
        });
      }
    }

    document.querySelectorAll('#goldenHomeTrendingTabs .ghProductMeta').forEach(function (meta) {
      meta.style.display = 'none';
      meta.style.visibility = 'hidden';
      meta.style.height = '0';
      meta.style.minHeight = '0';
      meta.style.margin = '0';
      meta.style.padding = '0';
    });

    document.querySelectorAll('#goldenHomeTrendingTabs .ghProductPrice').forEach(function (wrap) {
      var amount = wrap.querySelector('.ghMainPrice .ghPriceAmount');
      var currency = wrap.querySelector('.ghMainPrice .ghPriceCurrency');
      var compare = wrap.querySelector('.ghComparePrice');

      wrap.style.overflow = 'visible';
      wrap.style.marginTop = '0';

      if (amount) {
        amount.style.color = '#d60000';
        amount.style.textAlign = 'right';
        amount.style.justifySelf = 'end';
      }

      if (currency) {
        currency.style.background = '#000';
        currency.style.color = '#fff';
      }

      if (compare && !compare.classList.contains('isEmpty')) {
        compare.style.justifyContent = 'flex-end';
        compare.style.textAlign = 'right';
        compare.querySelectorAll('.ghPriceCurrency, .ghPriceAmount').forEach(function (el) {
          el.style.color = '#666';
          el.style.textDecoration = 'line-through';
          el.style.textAlign = 'right';
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSingleLogoAndTrending);
  } else {
    fixSingleLogoAndTrending();
  }

  window.addEventListener('resize', fixSingleLogoAndTrending);
  document.addEventListener('shopify:section:load', fixSingleLogoAndTrending);
})();
